import state from './system.state'
import mutations from './system.mutations'
import actions from './system.actions'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
